import { css, cx } from "@emotion/css";
import { Badge } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import type { MouseEvent } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BellIcon from "src/images/Icons/newIcons/bell.svg";

import { hasLimitedAccess } from "../../helpers/getPermissions";
import isMobile from "../../helpers/isMobile";
import { useGetNotificationCount } from "../../hooks/useNotifications";
import { IconButton } from "../Default/LekUI/Button";
import { SwipeableContent } from "../Default/LekUI/SwipableDrawer";
import { Tooltip } from "../Default/LekUI/Tooltip";
import Popper from "../NewComponents/Default/Popper";
import NotificationsContainer from "./NotificationsContainer";

function Notifications() {
	const { t } = useTranslation();
	const { data = 0, isLoading } = useGetNotificationCount(!hasLimitedAccess());
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	useEffect(() => {
		setAnchorEl(null);
	}, []);

	const onStatsClick = (e: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(e.currentTarget);
	};

	const close = () => {
		setAnchorEl(null);
	};

	const renderContent = () => {
		if (isMobile()) {
			return (
				<SwipeableContent isOpen={!!anchorEl} onClose={close}>
					<div
						className={cx(
							"ofy-auto",
							css`
                max-height: 400px;
              `,
						)}
						id="scrollableDiv"
					>
						{!!anchorEl && <NotificationsContainer />}
					</div>
				</SwipeableContent>
			);
		}

		return (
			<Popper className="" anchorEl={anchorEl}>
				<ClickAwayListener onClickAway={close}>
					<div
						className={cx(
							"popper of-auto",
							css`
                max-height: 400px;
                width: 320px;
              `,
						)}
						id="scrollableDiv"
					>
						<NotificationsContainer />
					</div>
				</ClickAwayListener>
			</Popper>
		);
	};

	return (
		<>
			<Tooltip title={t("tooltips.notifications")}>
				<IconButton
					isActive={!!anchorEl}
					onClick={onStatsClick}
					disabled={isLoading}
				>
					<Badge
						badgeContent={data}
						max={9}
						color="secondary"
						anchorOrigin={{
							vertical: "top",
							horizontal: "right",
						}}
					>
						<BellIcon className="icon-big" />
					</Badge>
				</IconButton>
			</Tooltip>
			{renderContent()}
		</>
	);
}

export default Notifications;
